export default "__VITE_ASSET__CLRYmbEB__"